<template>
  <section class="ui-component ui-form">
    <van-form
      ref="vanFormRef"
      v-model="model"
      v-bind="formProps"
      :class="attr.type"
    >
      <template v-for="(item, i) in useGroups" :key="i">
        <template v-if="item.type === 'multiSelect'">
          <div class="multiSelect" @click="onClick(item)">
            <van-field v-model="model[item.key]" :label="item.label" v-bind="item.props">
              <template #input>
                <div v-if="!params[item.key] || params[item.key]?.length === 0" class="placeholder van-field__control">
                  {{ `请选择${item.label}` }}
                </div>
                <div v-else class="pickerList">
                  <div v-for="(p, index) in getParkListOptions(params[item.key])" :key="p">
                    <van-tag
                      closeable
                      size="large"
                      type="primary"
                      @close="onClose(item, index)"
                    >
                      {{ parseDict(p, item.options || [], item) }}
                    </van-tag>
                  </div>
                </div>
                <van-icon
                  color="#969799"
                  size="18"
                  class="icon-down"
                  name="arrow"
                />
              </template>
            </van-field>
          </div>
        </template>
        <template v-else>
          <template
            v-if="
              ['select', 'cascader', 'treeSelect', 'datetimePicker', 'datetimeRangePicker'].includes(
                item.type
              )
            "
          >
            <van-field
              v-model="model[item.key]"
              :name="item.key"
              :label="item.label"
              :class="[
                `labelPosition-${item.props?.labelPosition || attr['label-position']
                }`
              ]"
              is-link
              :placeholder="`请选择${item.label}`"
              v-bind="item.props"
              :rules="item.props.required ? [{ required: true, message: `请选择${item.label}` }].concat(get(item, 'rules', [])) : get(item, 'rules', [])"
              @touchstart.prevent="onClick(item)"
              @click="onClick(item)"
            >
              <template #label>
                <slot :name="`${item.key}-label`" v-bind="item">
                  <span>{{ item.label }} </span>
                </slot>
              </template>
              <template
                v-if="[
                  'select',
                  'cascader',
                  'treeSelect',
                  'datetimePicker',
                  'datetimeRangePicker'
                ].includes(item.type) && Array.isArray(params[item.key])
                  ? params[item.key].length > 0
                  : !!params[item.key]"
                #input
              >
                <template v-if="item.type === 'datetimePicker'">
                  {{
                    params[item.key] &&
                      dayjs(new Date(params[item.key])).format(
                        item.props.valueFormat
                      )
                  }}
                </template>
                <template v-else-if="item.type === 'datetimeRangePicker'">
                  {{ params[item.key].join('至') }}
                </template>
                <template
                  v-else-if=" item.type === 'treeSelect' "
                >
                  {{
                    parseTreeDicts(
                      params[item.key],
                      item.options || [],
                      item
                    ).join('/')
                  }}
                </template>
                <template v-else-if="item.type === 'select'">
                  {{ parseDict(Number(params[item.key]), item.options || [], item) }}
                </template>
                <template v-else-if="item.type === 'cascader'">
                  {{ getDictValue(item.props.optionsTrget,params[item.key],item.props['field-names'].value) }}
                </template>
              </template>
            </van-field>
          </template>
          <template v-else-if="item.type === 'search'">
            <van-search v-model="params[item.key]" :placeholder="item.label" />
          </template>
          <template v-else-if="item.type === 'radio'">
            <van-field
              readonly
              :name="item.key"
              :label="item.label"
              v-bind="item.props"
            >
              <template #input>
                <van-radio-group v-model="params[item.key]" direction="horizontal">
                  <van-radio v-for="(o, index) in item.options" :key="index" :name="o.value">
                    {{ o.name }}
                  </van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </template>
          <template v-else>
            <template v-if="attr.type === 'inline'">
              <div class="inline-field" @click="onClick(item)">
                <span class="text" :class="params[item.key] ? 'value' : 'placeholder'">
                  {{ params[item.key] || item.label }}</span>
              </div>
            </template>
            <van-field
              v-else
              v-model="params[item.key]"
              :name="item.key"
              :label="item.label"
              :class="[
                `labelPosition-${item.props?.labelPosition || attr['label-position']
                }`
              ]"
              :placeholder="`请填写${item.label}`"
              v-bind="item.props"
              :rules="item.props.required ? [{ required: true, message: `请填写${item.label}` }].concat(get(item, 'rules', [])) : get(item, 'rules', [])"
            >
              <template v-if="item.label" #label>
                <slot :name="`${item.key}-label`" v-bind="item">
                  <span>{{ item.label }} </span>
                </slot>
              </template>
              <template v-if="item.props.suffix" #extra>
                <span>{{ item.props.suffix }}</span>
              </template>
              <template v-if="['slot', 'upload'].includes(item.type)" #input>
                <template v-if="item.type === 'slot'">
                  <slot :name="item.slotName" v-bind="item"></slot>
                </template>
                <template v-else>
                  <ImageUploader v-model:files="params[item.key]" />
                </template>
              </template>
            </van-field>
          </template>
        </template>
      </template>
    </van-form>
  </section>
  <van-popup v-model:show="popup.visible" position="bottom" teleport="body">
    <template v-if="popup.contentType === 'datetimeRangePicker'">
      <van-picker-group
        :tabs="['开始时间', '结束时间']"
        @confirm="onTimeRangeConfirm"
        @cancel="onClosePopup"
      >
        <van-date-picker
          v-model="params[pickerTime.originKey + '_start']"
          :min-date="minDate"
          :max-date="maxDate"
        />
        <van-date-picker v-model="params[pickerTime.originKey + '_end']" :min-date="minDate" :max-date="maxDate" />
      </van-picker-group>
    </template>
    <template v-else-if="popup.contentType === 'datetimePicker'">
      <van-date-picker
        v-if="popup.visible"
        v-model="params[pickerTime.originKey]"
        type="date"
        :title="pickerTime.title || '请选择'"
        v-bind="pickerTime.props"
        @confirm="onTimeConfirm"
        @cancel="onClosePopup"
      />
    </template>
    <template v-else-if="popup.contentType === 'cascader'">
      <van-cascader
        v-model="picker.value"
        :options="picker.options"
        v-bind="picker.props"
        @close="onCloseCascaderPopup"
      >
        <!-- <template #options-top="{ tabIndex }">
        </template> -->
      </van-cascader>
    </template>
    <template v-else>
      <van-picker
        v-if="popup.visible"
        v-model="picker.value"
        :columns="picker.options"
        :columns-field-names="picker.customFieldName"
        @confirm="onConfirm"
        @cancel="onClosePopup"
      >
        <template #title>
          <van-search
            v-model="pickerSearch"
            placeholder="快速搜索选项"
            wrap-with-form
            shape="round"
            style="width:60%"
            @search="onSearch"
          />
        </template>
      </van-picker>
    </template>
  </van-popup>
  <tree-select
    v-model:visible="treePopup.visible"
    v-model="params[treePopup.key]"
    :options="treePopup.options"
    :mapper="treePopup.mapper"
  />
</template>
<script lang="ts" setup>
import { computed, useAttrs, ref, watch, Ref, isRef } from 'vue'
import { cloneDeep, get, set } from 'lodash-es'
import dayjs from 'dayjs'
import { useStore } from 'vuex'
import TreeSelect from './treeSelect.vue'
import ImageUploader from '@/components/UI/upload/upload.vue'
import { getDictValue, imgPath, isArray } from '@/utils'
import { showToast } from 'vant'
const attr = useAttrs()
let minDate = new Date(2025, 9, 1)
let maxDate = new Date(2050, 10, 1)
function useDictOptions (useLabels: any[]) {
  const store = useStore()
  const dictData = computed<any>(() => store.getters.dictData || {})
  const labels = ref<any[]>([])
  initLabels()

  function initLabels () {
    useLabels.map((item: any) => {
      if (!!item.optionsPath) {
        item.options = get(dictData.value, item.optionsPath, [])
      }
    })
    labels.value = useLabels
    return useLabels
  }

  return {
    labels
  }
}


const props = defineProps({
  groups: { type: Array, default: () => [] },
  params: { type: Object, default: () => ({}) },
  formProps: { type: Object, default: () => ({}) },
  options: { type: Object, default: () => ({}) },
  treeMapper: {
    type: Object,
    default: () => ({ text: 'name', value: 'id', children: 'childList' })
  }
})
const emits = defineEmits(['update:params', 'setParams'])
// const mapper = { text: 'name', value: 'id', children: 'childList' }
const mapper = computed(() => props.treeMapper)
const popup = ref<any>({
  visible: false,
  contentType: ''
})
const picker = ref<any>({
  type: '',
  key: '',
  originKey: '',
  options: [],
  customFieldName: mapper.value
})
const pickerTime = ref<any>({
  key: ''
})
const model: Ref = ref<any>({})
const useGroups = computed<any>(() => {
  props.groups.map((item: any) => {
    if (Array.isArray(item.key)) {
      item.originKey = item.key
      item.key = item.key.join('_')
    } else {
      item.originKey = item.key
    }
  })
  return props.groups
})
useDictOptions(useGroups.value.map((group: any) => group.items || []).flat())
const current = ref()

watch(
  () => props.params,
  () => {
    useGroups.value.map((item: any) => {
      const types = ['select', 'cascader', 'multiSelect', 'datetimePicker','datetimeRangePicker']
      if (types.includes(item.type)) {
        if (Array.isArray(item.originKey)) {
          // 是多个key
          const modelValue: any = []
          item.originKey.map((k: string, index: number) => {
            const getValue = get(props.params, k)
            set(modelValue, `[${index}]`, getValue)
          })
          set(model.value, `${item.key}`, modelValue)
        } else {
          // 不是多个key
          let modelValue: any = get(props.params, item.key, '')
          if (Array.isArray(modelValue)) {
            // 数值是数组
            if (item.type === 'multiSelect') {
              // 多选
              modelValue = modelValue.join(',')
            } else {
              modelValue = parseDicts(modelValue, item.options || [], item) || modelValue
            }
          } else if (item.type === 'datetimePicker') {
            modelValue = modelValue ? new Date(modelValue).getTime() : ''
          } else if (item.type === 'datetimeRangePicker') {
            modelValue = []
          }


          set(model.value, `${item.key}`, modelValue)
        }
      } else {
        Object.keys(props.params).map(key => {
          set(model.value, `${key}`, get(props.params, key, ''))
        })
      }
    })
  },
  {
    immediate: true,
    deep: true
  }
)
const treePopup = ref({
  visible: false,
  key: '',
  originKey: '',
  options: [],
  mapper: mapper.value
})


let pickerSearch = ref('')
function onSearch(){
  let originFieldItem = useGroups.value.find((item: any) => item.key === picker.value.originKey)
  picker.value.options = originFieldItem.options.filter((item: any) => item[textKey.value].toLowerCase().indexOf(pickerSearch.value.toLowerCase()) !== -1) || []
}

function getParkListOptions (data) {
  if (isArray(data)) {
    return data
  } else {
    try {
      return data.split(',')
    } catch (error) {
      return []
    }
  }
}

function onClick (item: any) {
  current.value = item
  switch (true) {
    case ['treeSelect'].includes(item.type):
      treePopup.value.visible = true
      treePopup.value.originKey = item.originKey
      treePopup.value.key = item.key
      treePopup.value.options = cloneDeep(item.options || [])
      break
    case ['select', 'cascader', 'multiSelect'].includes(item.type):
      popup.value.visible = true
      popup.value.contentType = item.type
      popup.value.key = item.key
      picker.value.originKey = item.originKey
      picker.value.key = item.key
      picker.value.props = item.props || {}
      picker.value.options = cloneDeep(item.options || [])
      if (item.type === 'select') {
        picker.value.value = [props.params[item.key]]
      } else {
        picker.value.value = [props.params[item.key]]
      }
      model.value[item.key] = props.params[item.key]
      picker.value.customFieldName = Object.assign(
        {},
        mapper.value,
        props?.options?.mapper,
        item.mapper
      )
      break
    case ['datetimePicker', 'datetimeRangePicker'].includes(item.type):
      popup.value.visible = true
      model.value[item.key] = props.params[item.key]
      popup.value.contentType = item.type
      pickerTime.value.originKey = 'origin_' + item.key
      pickerTime.value.key = item.key
      pickerTime.value.props = item.props || {}
      break
    default:
      break
  }
}

const valueKey = computed(() => picker.value.customFieldName.value)
const textKey = computed(() => picker.value.customFieldName.text)

function onConfirm (value: any) {
  if (current.value.type === 'multiSelect') {
    const realValue = value.selectedValues.join('')
    const already = model.value[picker.value.key]
      ? model.value[picker.value.key].split(',')
      : []
    already.push(realValue)
    const uniArr = Array.from(new Set(already))
    model.value[picker.value.key] = uniArr.join(',')
  } else if (current.value.type === 'cascader') {
    const values = value.map((item: any) => item[valueKey.value])
    const names = value.map((item: any) => item[textKey.value])
    model.value[picker.value.key] = values

    if (Array.isArray(picker.value.originKey)) {
      picker.value.originKey.map((k: string, index: number) => {
        set(model.value, k, get(values, index))
      })
    } else {
      set(model.value, picker.value.originKey, values)
    }
  } else if (current.value.type === 'select') {
    set(model.value, picker.value.key, value.selectedValues)
  } else {
    set(model.value, picker.value.key, value[valueKey.value])
  }
  setParams()
  onClosePopup()
}

function onClose (item: any, index: number) {
  const data = props.params[item.key]
  let arrayData = data.split(',')
  arrayData.splice(index, 1)
  set(props.params, item.key, arrayData.join(','))
}

function parseTreeDicts (values: any[], options: any[], item?: any) {
  const vk =
    Object.assign(mapper.value, props?.options?.mapper, item?.mapper).value ||
    ''
  const ck =
    Object.assign(mapper.value, props?.options?.mapper, item?.mapper)
      .children || ''
  if (Array.isArray(values) && values.length > 0) {
    const valuesName: any = []
    parseChild(values[0], options, 0)
    function parseChild (value: any, options: any[], index: number) {
      if (index < values.length) {
        const text = parseDict(value, options, item)
        valuesName.push(text)
        const childOptions = options.find((opt: any) => opt[vk] === values[index])?.[
          ck
        ]
        parseChild(values[index + 1], childOptions, index + 1)
      }
    }
    return valuesName
  } else {
    return []
  }
}

function parseDicts (values: any[], options: any[], item?: any) {
  const vk =
    Object.assign(
      mapper.value,
      props?.options?.mapper || {},
      item?.mapper || {}
    ).value || ''
  const tk =
    Object.assign(
      mapper.value,
      props?.options?.mapper || {},
      item?.mapper || {}
    ).text || ''
  return values.map((value: any) => {
    return (options || []).find(opt => opt[vk] === value)?.[tk]
  })
}

function parseDict (value: any, options: any[], item: any) {
  let useOptions = isRef(options) ? options.value : (options || [])
  const vk =
    Object.assign(
      mapper.value,
      props?.options?.mapper || {},
      item?.mapper || {}
    ).value || ''
  const tk =
    Object.assign(
      mapper.value,
      props?.options?.mapper || {},
      item?.mapper || {}
    ).text || ''


  return useOptions.find(opt => opt[vk] == value)?.[tk] || value
}

function formatDate (date: any, valueFormat: string) {
  // 处理时间戳的情况
  if (typeof date === 'number') {
    date = new Date(date)
  }

  // 确保是有效的 Date 对象
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    throw new Error('Invalid date')
  }

  const format = valueFormat || 'YYYY-MM-DD'
  if (format == 'x') {
    return date.getTime()
  }
  const formatObj = {
    Y: date.getFullYear(),
    M: date.getMonth() + 1,
    D: date.getDate(),
    H: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  } as any

  const timeStr = format.replace(/(Y|M|D|H|i|s|a)+/g, (result: any, key: string | number) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || '0'
  })


  return timeStr
}

function onTimeConfirm (value: any) {

  let { selectedValues } = value
  let valueFormat = get(pickerTime.value, 'props.valueFormat', 'YYYY-MM-DD')
  set(model.value, pickerTime.value.originKey, formatDate(new Date(selectedValues.join('-')), valueFormat))
  setParams()
  onClosePopup()
}
function onTimeRangeConfirm (value: any) {
  let { selectedValues } = value
  let startSelectedValues = value[0].selectedValues
  let endSelectedValues = value[1].selectedValues
  if (endSelectedValues.join('-') < startSelectedValues.join('-')) {
    showToast('结束时间不能小于开始时间')
    return
  }
  let valueFormat = get(pickerTime.value, 'props.valueFormat', 'YYYY-MM-DD')
  set(model.value, pickerTime.value.originKey + '_start', startSelectedValues)
  set(model.value, pickerTime.value.originKey + '_end', endSelectedValues)
  // 如果结束时间小于开始时间，提示用户

  setParams()
  onClosePopup()
}


function setParams () {
  const paramsObj = cloneDeep(props.params)
  useGroups.value.map((item: any) => {
    const types = ['select', 'cascader', 'multiSelect', 'datetimePicker','datetimeRangePicker']
    if (types.includes(item.type)) {
      if (Array.isArray(item.originKey)) {
        const modelValue: any = []
        item.originKey.map((k: string, index: number) => {
          const getValue = get(model.value, k)
          set(modelValue, `[${index}]`, getValue)
        })
        set(paramsObj, `${item.key}`, modelValue)
      } else {
        let modelValue: any = get(model.value, item.key, '')
        if (item.type === 'multiSelect' || item.type === 'cascader') {
          // modelValue = modelValue && modelValue.split(',')
          set(paramsObj, `${item.key}`, modelValue)
        }
        if (item.type === 'datetimePicker' && pickerTime.value.originKey) {
          let valueFormat = get(pickerTime.value, 'props.valueFormat', 'YYYY-MM-DD')
          modelValue = get(model.value, pickerTime.value.originKey, '')
          set(
            paramsObj,
            `${pickerTime.value.originKey.split('_')[1]}`,
            isArray(modelValue) ? formatDate(new Date(modelValue.join('-')), valueFormat) : modelValue
          )
        }
        if (item.type === 'datetimeRangePicker') {
          let valueFormat = get(pickerTime.value, 'props.valueFormat')
          modelValue = get(model.value, pickerTime.value.originKey + '_start', '')
          set(
            paramsObj,
            `${pickerTime.value.originKey}_start`,
            modelValue
          )
          modelValue = get(model.value, pickerTime.value.originKey + '_end', '')
          set(
            paramsObj,
            `${pickerTime.value.originKey}_end`,
            modelValue
          )
          set(
            paramsObj,
            `${pickerTime.value.key}`,
            [
              get(model.value, pickerTime.value.originKey + '_start', '').join('-'),
              get(model.value, pickerTime.value.originKey + '_end', '').join('-')
            ]
          )
        }
        if (item.type === 'select') {
          set(paramsObj, `${item.key}`, isArray(modelValue) ? modelValue.join('') : modelValue)
        }
      }
    }
  })

  emits('update:params', paramsObj)
  emits('setParams', paramsObj)
}
function onClosePopup () {
  popup.value.visible = false
}
function onCloseCascaderPopup () {
  let { value,originKey } = picker.value
  model.value[originKey] = value
  setParams()
  onClosePopup()
}

const vanFormRef: any = ref(null)

async function validate () {
  try {
    await vanFormRef.value.validate()
    return true
  } catch {
    return false
  }
}

defineExpose({
  validate
})
</script>
<style lang="scss" scoped>
.ui-form {
  background-color: #fff;

  :deep {

    .van-field__label--required::before,
    .van-field__error-message {
      color: red;
    }

    &.van-cell-group:last-child {
      margin-bottom: 0;
    }

    .multiSelect {
      .placeholder {
        color: $primary-color-placeholder;
      }

      .pickerList {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
      }

      .pickerList > div {
        flex: 0 0 1;
        margin-bottom: 5px;
        margin-right: 5px;
      }

      .icon-down {
        width: 16px;
        // height: 12px;
        margin-left: 6px;
      }
    }

    div.labelPosition-top {
      display: flex;
      flex-direction: column;
      position: relative;

      .van-field__label {
        max-width: 100%;
        width: 100% !important;
        margin-bottom: 6px;
      }

      .van-field__value {
        width: 100%;
      }

    }
  }

  .inline {
    display: flex;
    justify-content: space-around;
    align-items: center;

    .inline-field {
      padding: 5px 15px;
      margin: 5px;
      flex: 1;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;

      &:not(:last-child) {
        position: relative;

        &:after {
          content: '';
          position: absolute;
          width: 0;
          right: -5px;
          height: 60%;
          top: 20%;
        }
      }

      img {
        width: 8px;
      }

      .text {
        display: inline-block;
        margin-right: 5px;

        &.placeholder {
          color: #c8c9cc;
        }

        @include ellipsisMultiline(1);
      }

    }
  }
}
</style>
